module.exports = __webpack_public_path__ + "static/media/ic-arrow-right.ae579798.svg";